import { useCallback, useState } from 'react'

const findRoot = (dom: HTMLElement): HTMLElement | null => {
  if (Array.from(dom.classList).includes('MuiFormControl-root')) return dom

  if (!dom.parentElement) return null

  return findRoot(dom.parentElement)
}

const useMenuAnchorEl = (disable: boolean) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
  const [open, setOpen] = useState(false)

  const onOpen = useCallback(
    (e: React.MouseEvent<HTMLInputElement>) => {
      if (disable) return

      setMenuAnchorEl(findRoot(e.target as HTMLElement))
      setOpen(true)
    },
    [disable, setMenuAnchorEl, setOpen],
  )
  const onClose = useCallback(() => {
    setMenuAnchorEl(null)
    setOpen(false)
  }, [setMenuAnchorEl, setOpen])

  return {
    menuAnchorEl,
    open,
    onOpen,
    onClose,
  }
}

export default useMenuAnchorEl
